import { Routes } from '@angular/router';
import { sessionGuard, callGuard } from './guards/session.guard';
import { browserSupportGuard } from './guards/browser-support.guard';

export const routes: Routes = [
  // {
  //   path: 'home',
  //   loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  // },
  {
    // Pantalla de navegador no compatible (Safari). Sin guard para evitar loops.
    path: 'unsupported-browser',
    loadComponent: () =>
      import('./pages/unsupported-browser/unsupported-browser.page').then(
        (m) => m.UnsupportedBrowserPage
      ),
  },
  {
    path: 'lobby',
    canActivate: [browserSupportGuard, sessionGuard],
    loadComponent: () => import('./pages/lobby/lobby.page').then((m) => m.LobbyPage),
  },
  {
    path: 'call',
    canActivate: [browserSupportGuard, callGuard],
    loadComponent: () => import('./pages/call/call.page').then((m) => m.CallPage),
  },
  {
    path: 'call-ended',
    loadComponent: () => import('./pages/call-ended/call-ended.page').then((m) => m.CallEndedPage),
  },
  {
    path: 'error',
    loadComponent: () => import('./pages/error/error.page').then((m) => m.ErrorPage),
  },
  {
    path: ':hash',
    canActivate: [browserSupportGuard],
    loadComponent: () => import('./pages/entry/entry.page').then((m) => m.EntryPage),
  },
  {
    path: '',
    redirectTo: 'error',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'error',
  },
];
